<h2>{{this.line ? this.line.factoryName + ' — ' + this.line.name + ' ' : ''}}Changeover Schedule</h2>
<div class="content">
  <div class="actions">
    <button mat-button [routerLink]="['add']">
      <mat-icon>add</mat-icon>NEW
    </button>
  </div>
  <div class="agenda centering-container" *ngIf="this.isBusyLoading">
    <mat-spinner></mat-spinner>
  </div>
  <div class="agenda" *ngIf="!this.isBusyLoading">
    <mat-list>
      <ng-container *ngFor="let group of this.agendaItems">
        <div mat-subheader>{{group.date}}</div>
        <mat-list-item *ngFor="let item of group.items">
          <div mat-line>{{item.time}} — {{item.type}}</div>
          <div mat-line><span class="subheader">From:</span>{{item.from}}</div>
          <div mat-line><span class="subheader">To:</span>{{item.to}}</div>

          <span class="flex-spacer"></span>
          <button mat-button (click)="this.deleteChangeover(item.id)">
            <mat-icon mat-list-icon>delete</mat-icon>
          </button>
          <mat-divider></mat-divider>
        </mat-list-item>
      </ng-container>
    </mat-list>
  </div>
</div>